const childRoutes = (prop) => [
  {
    path: 'product-category-list',
    name: prop + '.product_category_list',
    meta: { auth: true },
    component: () => import('../pages/product-category/List.vue')
  },
  {
    path: 'product-sub-category-list',
    name: prop + '.product_sub_category_list',
    meta: { auth: true },
    component: () => import('../pages/product-sub-category/List.vue')
  },
  {
    path: 'unit-info-list',
    name: prop + '.unit_info_list',
    meta: { auth: true },
    component: () => import('../pages/unit-info/List.vue')
  },
  {
    path: 'product-name-list',
    name: prop + '.product_name_list',
    meta: { auth: true },
    component: () => import('../pages/product-name/List.vue')
  },
  {
  path: 'price-info-list',
  name: prop + '.price_info_list',
  meta: { auth: true },
  component: () => import('../pages/price-info/List.vue')
},
  {
    path: 'factory-info-list',
    name: prop + '.factory_info_list',
    meta: { auth: true },
    component: () => import('../pages/factory-info/List.vue')
  },
  {
    path: 'sales-center-info',
    name: prop + '.sales_center_info',
    meta: { auth: true },
    component: () => import('../pages/sales-center-info/List.vue')
  },
  {
    path: 'vehicle-info-list',
    name: prop + '.vehicle_info_list',
    meta: { auth: true },
    component: () => import('../pages/vehicle-info/List.vue')
  },
  {
    path: 'sales-center-info',
    name: prop + '.sales_center_info',
    meta: { auth: true },
    component: () => import('../pages/sales-center-info/List.vue')
  },
  {
      path: 'promotion-type',
      name: prop + '.promotion_type',
      meta: { auth: true },
      component: () => import('../pages/promotion-type/List.vue')
  },
  {
    path: 'case-mapping-list',
    name: prop + '.case_mapping_list',
    meta: { auth: true },
    component: () => import('../pages/case-mapping/List.vue')
  },
  {
    path: 'designation-info-list',
    name: prop + '.designation_info_list',
    meta: { auth: true },
    component: () => import('../pages/designation-info/List.vue')
  },
  {
    path: 'user-info-list',
    name: prop + '.user_info_list',
    meta: { auth: true },
    component: () => import('../pages/user-info/List.vue')
  },
  {
    path: 'dealer-retailer-info',
    name: prop + '.dealer_retailer_info',
    meta: { auth: true },
    component: () => import('../pages/dealer-retailer-info/List.vue')
  },
  {
    path: 'dealer-retailer-info-form',
    name: prop + '.dealer_retailer_info_form',
    meta: { auth: true },
    component: () => import('../pages/dealer-retailer-info/EntryForm.vue')
  },
  {
    path: 'report-heading-list',
    name: prop + '.report_heading_list',
    meta: { auth: true },
    component: () => import('../pages/report-heading/List.vue')
  },
  {
    path: 'security-money',
    name: prop + '.security_money',
    meta: { auth: true },
    component: () => import('../pages/security-money/List.vue')
  },
  {
    path: 'supplier-info',
    name: prop + '.supplier_info',
    meta: { auth: true },
    component: () => import('../pages/supplier-info/List.vue')
  },
  {
    path: 'supplier-info-form',
    name: prop + '.supplier_info_form',
    meta: { auth: true },
    component: () => import('../pages/supplier-info/EntryForm.vue')
  },
  {
    path: 'received-notifications',
    name: prop + '.received_notifications',
    meta: { auth: true },
    component: () => import('../pages/received-notifications/List.vue')
  },
  {
    path: 'activity-log',
    name: prop + '.activity_log',
    meta: { auth: true },
    component: () => import('../pages/activity-log/List.vue')
  }
]
const routes = [{
  path: '/production-service/configuration',
  name: 'production_service.configuration',
  component: () => import('@/layouts/ProductionLayout.vue'),
  meta: { auth: true },
  children: childRoutes('production_service.configuration')
}]

export default routes
